import { logEvent } from 'firebase/analytics';
import React, { Component } from 'react'
import ReactPlayer from 'react-player'
import { analytics } from '../config/firebase';
import '../css/video-player.css';

class Video extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasInteracted: false
        };
    }

    eventOnPlay=(e)=> {
        try {
            logEvent(analytics, 'yt played');
            console.log('yt played')
        } catch (error) {
            console.log('Analytics logging failed:', error);
        }
    }

    handleClick = () => {
        this.setState({ hasInteracted: true });
    }

    render () {
        const { hasInteracted } = this.state;
        
        return (
        <div className={"player-wrapper "+this.props.className} onClick={this.handleClick}>
            <ReactPlayer
            className='react-player'
            url= {this.props.url}
            width={this.props.width}
            height={this.props.height}
            controls = {true}
            /* `light` renders a poster image and mounts nothing until it is
               clicked. `preload: 'metadata'` alone did NOT work: measured in
               Chrome, the homepage pulled all 3,599KB of ntvideo.mp4 on load,
               on mobile too, for a video most visitors never play — 55% of the
               page weight. With a poster the video costs nothing until wanted. */
            light={this.props.poster || false}
            playing={hasInteracted}
            muted={true}
            playsinline={true}
            onStart={this.eventOnPlay}
            onError={(error) => console.log('Video error:', error)}
            config={{
                file: {
                    attributes: {
                        preload: 'none'
                    }
                }
            }}
            />
        </div>
        )
    }
}

export default Video;